import React from 'react'
import { Link } from 'gatsby'
import styled from "styled-components"

import { rhythm } from '../utils/typography'

const Container = styled.div`
  @media (min-width: 1200px) {
    margin: 20px 20%;
  }

  @media (max-width: 1200px) {
    margin: 20px 5%;
  }
`

class Layout extends React.Component {
  render() {
    const { location, config, children, translations } = this.props
    return (
      <Container>
        {children}
      </Container>
    )
  }
}

export default Layout
